export const WHATSAPP_NUMBER = "+447405985739";
export const WHATSAPP_NUMBER_DIGITS = WHATSAPP_NUMBER.replace(/\D/g, "");
export const WHATSAPP_DISPLAY = "+44 (0) 7405 985739";
export const CONTACT_EMAIL = "info@jobboost.uk";
export const DOMAIN = "jobboost.uk";

export const brand = {
  name: "Job Boost by Ben",
  tagline: "Empowering people. Building confidence. Creating brighter futures.",
};

export const packagePrices = {
  cvReview: "From £25",
  cvRewrite: "From £45",
  cvCoverLetter: "From £65",
  interviewPrep: "From £35",
  linkedInRefresh: "From £40",
  youngPersonStarter: "From £30",
};

export const images = {
  hero: "/job-search-desk-hero.webp",
  heroClassroom: "/hero-classroom-training.webp",
  heroPresenting: "/hero-ben-presenting.webp",
  heroGroup: "/hero-young-people-group.webp",
  about: "/benjamin-james-portrait.webp",
  aboutCard: "/benjamin-james-portrait-card.webp",
  adultsReturning: "/adults-returning-to-work.webp",
  youngPeople: "/young-people-positive-directions.webp",
  youngPeopleAchievement: "/young-people-achievement-award.webp",
  youngPeopleAchievementCard: "/young-people-achievement-card.webp",
  servicesYoungPersonCertificates: "/services-young-person-certificates.webp",
  parentsCarersSupport: "/parents-carers-support-card.webp",
  churchCommunitySupport: "/church-community-support-card.webp",
  localOrganisationsSupport: "/local-organisations-support-card.webp",
  careerChangers: "/career-changers-coaching.webp",
};